
/* eslint-disable no-console */

import { Component, State } from 'nuxt-property-decorator';
import TooltipButton from '../../TooltipButton.vue';
import ToastService, { ToastType } from '../../toast/ToastService';
import ContextuallySortedList from '../ContextuallySortedList';
import CloseBtn from '../CloseBtn.vue';
import BookmarkItem from './BookmarkItem.vue';
import UserSettingsStore, { Bookmark } from '@/store/userSettings.store';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import { Site } from '@/types/initialData';
import KeyHandleEventBus from '@/store/keyHandle.eventbus';
import { nrPageAction } from '@/util/newrelic-browser';

@Component({
  components: {
    CloseBtn,
    TooltipButton,
    BookmarkItem
  }
})
export default class BookmarksList extends ContextuallySortedList {
  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.id) // notice : there's also id, and that reflects the query param
  pageId: number;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.navigation[0]?.title)
  bookTitle: string;

  get bookmarks(): Bookmark[] {
    const contentList = this.sortedCIDList;
    const pageList = this.sortedPidList;
    return (
      UserSettingsStore.bookmarks?.sort(
        this.sortBookmarksByPidAndCid(contentList, pageList)
      ) || []
    );
  }

  async deleteBookmark(bookmark: Bookmark) {
    try {
      await UserSettingsStore.deleteBookmark(bookmark, this.site);
      ToastService.showToast(
        this.$i18n.t('labels.bookmarks.deleted') as string,
        ToastType.Success
      );
      /* User clicked delete bookmark in bookmarks list */
      nrPageAction('BookMark', {
        action: 'Delete',
        type: 'Button',
        component: 'Bookmarks'
      });
    } catch (e) {
      console.error('Error removing bookmark', e);
    }
  }

  navigateToBookmark(bookmark: Bookmark) {
    const currentPId = Number(this.$route.query.id);
    if (bookmark.pageId !== currentPId) {
      this.$router.push({ query: { id: bookmark.pageId.toString(10) } });
      /* User clicked navigate to bookmark in bookmarks list */
      nrPageAction('BookMark', {
        action: 'NavigateToBookMark',
        type: 'Button',
        component: 'Bookmarks'
      });
    }
  }

  closeList(): void {
    SidePanelStore.rightPanelIsOpen = false;
  }

  mounted() {
    KeyHandleEventBus.$on('escape', this.closeList);
  }

  destroyed() {
    KeyHandleEventBus.$off('escape', this.closeList);
  }

  private sortBookmarksByPidAndCid(contentList: string[], pageList: number[]) {
    return (a: Bookmark, b: Bookmark) => {
      if (a.pageId === b.pageId) {
        const aLoc = contentList.indexOf('' + a.contentId);
        const bLoc = contentList.indexOf('' + b.contentId);
        return aLoc - bLoc;
      }

      const aPidLoc = pageList.indexOf(a.pageId);
      const bPidLoc = pageList.indexOf(b.pageId);
      return aPidLoc - bPidLoc;
    };
  }
}
